var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "search",
                  attrs: { model: _vm.searchForm, inline: true, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入商品名称", clearable: "" },
                        model: {
                          value: _vm.searchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "name", $$v)
                          },
                          expression: "searchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "五域商品编号", prop: "goodsNo" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入商品编号" },
                        model: {
                          value: _vm.searchForm.goodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "goodsNo", $$v)
                          },
                          expression: "searchForm.goodsNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类型", prop: "goodsType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: {
                            placeholder: "请选择商品类型",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.goodsType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "goodsType", $$v)
                            },
                            expression: "searchForm.goodsType",
                          },
                        },
                        _vm._l(_vm.goods_types, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          on: { change: _vm.selectStatusS },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.platform_goods_status,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间", prop: "brandId" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.createdAt,
                          callback: function ($$v) {
                            _vm.createdAt = $$v
                          },
                          expression: "createdAt",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上架时间", prop: "brandId" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.upTime,
                          callback: function ($$v) {
                            _vm.upTime = $$v
                          },
                          expression: "upTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品上下架", prop: "wyGoodsStatus" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          model: {
                            value: _vm.searchForm.wyGoodsStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "wyGoodsStatus", $$v)
                            },
                            expression: "searchForm.wyGoodsStatus",
                          },
                        },
                        _vm._l(_vm.wyGoodsStatusList, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("h3", [_vm._v("列表数据")]),
        _c("div", { staticClass: "btn-list" }, [
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.selectStatus },
                  model: {
                    value: _vm.radio1,
                    callback: function ($$v) {
                      _vm.radio1 = $$v
                    },
                    expression: "radio1",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "3", border: "" } }, [
                    _vm._v(
                      "全部(" +
                        _vm._s(_vm.countGroupByStatus.psGoodsTotal) +
                        ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "2" } }, [
                    _vm._v(
                      "待上架(" +
                        _vm._s(_vm.countGroupByStatus.psGoodsTotalWait) +
                        ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "1" } }, [
                    _vm._v(
                      "上架(" +
                        _vm._s(_vm.countGroupByStatus.psGoodsTotalPassUp) +
                        ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "0" } }, [
                    _vm._v(
                      "下架(" +
                        _vm._s(_vm.countGroupByStatus.psGoodsTotalPassDown) +
                        ")"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { attrs: { calss: "item" } }),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.searchForm.pageNo,
                "page-size": _vm.searchForm.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isUp,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isUp = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { color: "red", "font-size": "16px" },
              }),
              _vm._v("是否确认该商品上架 "),
            ]),
            _c("div", { staticClass: "info-b" }, [
              _vm._v("该商品是否已编辑信息？可编辑后上架！"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isUp = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.submitUp } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }